import './src/scss/style.scss'
import { browserService } from './src/srv/browser.service'

export const onClientEntry = browserService.onClientEntry
export const onRouteUpdate = browserService.onRouteUpdate
export const wrapPageElement = browserService.wrapPageElement
export const shouldUpdateScroll = browserService.shouldUpdateScroll
